import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export const Route = createFileRoute("/cookies")({
  head: () => ({
    meta: [
      { title: "Cookie-Einstellungen, OM Selected" },
      { name: "description", content: "Cookie-Einstellungen verwalten und Einwilligung widerrufen." },
      { name: "robots", content: "index, follow" },
      { property: "og:title", content: "Cookie-Einstellungen, OM Selected" },
      { property: "og:description", content: "Cookie-Einstellungen verwalten und Einwilligung widerrufen." },
      { property: "og:url", content: "https://omselected.art/cookies" },
    ],
    links: [{ rel: "canonical", href: "https://omselected.art/cookies" }],
  }),
  component: CookiesPage,
});

function CookiesPage() {
  const [status, setStatus] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    setStatus(localStorage.getItem("oms-cookie-consent"));
  }, []);

  const update = (value: "accepted" | "declined" | null) => {
    if (value === null) {
      localStorage.removeItem("oms-cookie-consent");
    } else {
      localStorage.setItem("oms-cookie-consent", value);
    }
    setStatus(value);
    window.dispatchEvent(new Event("oms-cookie-consent-change"));
  };

  return (
    <article className="mx-auto max-w-2xl px-5 md:px-10 py-20">
      <h1 className="serif text-4xl md:text-5xl mb-10">Cookie-Einstellungen</h1>

      <div className="space-y-6 text-sm leading-relaxed text-foreground/90">
        <p className="text-muted-foreground">
          Wir verwenden technisch notwendige Cookies für den Betrieb der Website (z. B. Login).
          Diese sind nicht abwählbar. Optionale Cookies setzen wir nur mit Deiner Einwilligung.
        </p>

        <div className="rounded border border-border p-5">
          <div className="eyebrow text-muted-foreground mb-2">Aktueller Status</div>
          <div className="serif text-xl">
            {status === "accepted" && "Optionale Cookies akzeptiert"}
            {status === "declined" && "Optionale Cookies abgelehnt"}
            {!status && "Noch keine Auswahl getroffen"}
          </div>
        </div>

        <div className="flex flex-wrap gap-3">
          <button
            onClick={() => update("accepted")}
            className="rounded bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          >
            Alle akzeptieren
          </button>
          <button
            onClick={() => update("declined")}
            className="rounded border border-input bg-background px-4 py-2 text-sm font-medium hover:bg-accent"
          >
            Ablehnen
          </button>
          <button
            onClick={() => update(null)}
            className="rounded px-4 py-2 text-sm text-muted-foreground hover:text-foreground"
          >
            Auswahl zurücksetzen
          </button>
        </div>

        <h2 className="serif text-2xl mt-10">Verwendete Cookies</h2>
        <ul className="space-y-3 text-muted-foreground">
          <li>
            <strong className="text-foreground">Notwendig:</strong> Session-Cookies der
            Authentifizierung (Supabase). Erforderlich für Login und gesicherte Bereiche.
          </li>
          <li>
            <strong className="text-foreground">Funktional/Analyse:</strong> Werden nur nach
            Einwilligung gesetzt. Aktuell setzen wir keine Analyse-Cookies, sobald wir das tun,
            steuern wir sie über diese Einstellung.
          </li>
        </ul>
      </div>
    </article>
  );
}